export const normalizeUserId = (
  value?: number | string | null,
): number | undefined => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "") return undefined;
    const numericValue = Number(trimmed);
    return Number.isFinite(numericValue) ? numericValue : undefined;
  }
  return undefined;
};

export const isSameUserId = (
  left?: number | string | null,
  right?: number | string | null,
): boolean => {
  const leftId = normalizeUserId(left);
  const rightId = normalizeUserId(right);
  if (leftId === undefined || rightId === undefined) return false;
  return leftId === rightId;
};
